import {  createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../../store';
import { setLsItem , clearLs } from '../../../Utils';
import { User ,UserRoles} from '../../../Utils/Types';
// import { fetchCount } from './counterAPI';
import { login } from './LoginAPI'

export interface UserAuthState {
  token: string;
  user: User | null
  status: 'idle' | 'loading' | 'failed' | 'logged-in';
  isloggedIn: boolean;
}

const initialState: UserAuthState = {
  token: '',
  user: null,
  status: 'idle',
  isloggedIn: false
};
let dummyUser: User = {
  email: "dummyuser@dummy.com",
  firstName: "Dummy",
  lastName: "User",
  username: "duumy7688",
  role: "Director",
  isAdmin: true
  
}


export const userAuthSlice = createSlice({
  name: 'userAuth',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setToken: (state , action) => {
      setLsItem("access_token",action.payload )
      state.token = ''
      state.user = dummyUser
      state.status = 'logged-in'
      state.isloggedIn = true
    },
    logout: (state) => {
      state.isloggedIn = false
      clearLs()
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(login.fulfilled, (state, action) => {
        state.status = 'idle';
        
      })
      .addCase(login.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { setToken , logout  } = userAuthSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectAuth = (state: RootState) => state.userAuth

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
// export const incrementIfOdd =
//   (amount: number): AppThunk =>
//   (dispatch, getState) => {
//     const currentValue = selectCount(getState());
//     if (currentValue % 2 === 1) {
//       dispatch(incrementByAmount(amount));
//     }
//   };

export default userAuthSlice.reducer;
